<template>
  <Modal width="600" v-model="show" title="批量操作结果" :mask-closable="false" class-name="vertical-center-modal" @on-ok="$emit('on-ok')">
    <Table height="300" :columns="columns" :data="data"></Table>
  </Modal>
</template>
<script>
export default {
  name: 'betchError',
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
